import { ClientType } from '../../api/ClientApi';

export const isSupplierPage = (path?: string) => {
    if (!path) {
        return false;
    }

    return path.includes('suppliers');
};

export const isCustomerPage = (path?: string) => {
    if (!path) {
        return false;
    }

    return path.includes('customers');
};

export const isSupplier = (clientType?: ClientType) => {
    if (!clientType) {
        return false;
    }

    return clientType === ClientType.Supplier;
};

export const isCustomer = (clientType?: ClientType) => {
    if (!clientType) {
        return false;
    }

    return clientType === ClientType.Customer;
};
